import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const User = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22C6.49 22 2 17.51 2 12ZM3.25 12C3.25 16.83 7.17 20.75 12 20.75C16.83 20.75 20.75 16.83 20.75 12C20.75 7.17 16.83 3.25 12 3.25C7.17 3.25 3.25 7.17 3.25 12ZM12 12.74C14.23 12.74 16.05 10.92 16.05 8.69C16.05 6.46 14.23 4.64 12 4.64C9.76995 4.64 7.94995 6.46 7.94995 8.69C7.94995 10.92 9.76995 12.74 12 12.74ZM12 5.89C13.54 5.89 14.8 7.15 14.8 8.69C14.8 10.23 13.54 11.49 12 11.49C10.46 11.49 9.19995 10.23 9.19995 8.69C9.19995 7.15 10.46 5.89 12 5.89ZM18.18 16.69C17.31 15.04 15.85 13.83 14.07 13.27C12.29 12.72 10.4 12.89 8.75001 13.76C7.50001 14.42 6.49001 15.43 5.83001 16.68C5.67001 16.99 5.79001 17.36 6.09001 17.52C6.18001 17.57 6.28001 17.59 6.38001 17.59C6.60001 17.59 6.82001 17.47 6.93001 17.26C7.47001 16.23 8.30001 15.4 9.33001 14.86C10.69 14.15 12.24 14 13.7 14.46C15.16 14.91 16.36 15.91 17.08 17.26C17.24 17.57 17.62 17.68 17.92 17.52C18.23 17.36 18.34 16.98 18.18 16.68V16.69Z"
    />
  </svg>
)

export default withDefaultStyles(User)
